import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { GenericModal } from '@org/ui';
import { StudentMultiStepForm } from '../../app/components/student/student-multi-step-form';
import { trpc } from '@org/clients/school';
import { unwrapTrpcData } from '@org/ui';

export const Route = createFileRoute('/students/$studentId')({
  component: StudentDetailRoute,
});

function StudentDetailRoute() {
  const { studentId } = Route.useParams();
  const navigate = useNavigate({ from: '/students/$studentId' });
  const utils = trpc.useUtils();
  const { data, isLoading } = trpc.users.get.useQuery({ id: studentId });
  const student = unwrapTrpcData(data);

  const handleClose = () => {
    navigate({ to: '/students', replace: true });
  };

  const handleSubmit = async () => {
    await utils.users.list.invalidate();
    handleClose();
  };

  return (
    <GenericModal
      show
      onClose={handleClose}
      title="Edit Student"
      size="xl"
      centered
      body={
        isLoading ? (
          <div className="flex h-40 items-center justify-center text-muted-foreground">
            Loading student...
          </div>
        ) : student ? (
          <StudentMultiStepForm
            defaultValues={student}
            onSubmit={handleSubmit}
            onClose={handleClose}
            isEditing
          />
        ) : (
          <div className="flex h-40 items-center justify-center text-muted-foreground">
            Unable to locate student.
          </div>
        )
      }
      footer={<></>}
    />
  );
}


